import { z } from 'zod';

import type { TpaInput } from '@/lib/api/domains/tpas';

/*
 * TPA form schema. Mirrors the provider/general-agent/invoice/client form
 * pattern: a Zod schema for the fields the user edits, plus a `toTpaInput`
 * transform to the API input shape. The prototype TPA record
 * (`{id, public_id, name, tin, created_on}`) has neither a DBA name nor an NPN,
 * so — unlike general-agents — the only edited field beyond name is status.
 */
export const tpaFormSchema = z.object({
  name: z.string().min(1, 'Name is required.'),
  status: z.enum(['active', 'inactive']),
});

export type TpaFormValues = z.infer<typeof tpaFormSchema>;

/** Convert form values to the API input shape. */
export function toTpaInput(values: TpaFormValues): TpaInput {
  return {
    name: values.name,
    status: values.status,
  };
}
